import { supabase } from "@/integrations/supabase/client";
import type { Tables } from "@/integrations/supabase/types";
import { Category, Subcategory } from "@/data/types";

export type DbCategory = Tables<"categories">;
export type DbSubcategory = Tables<"subcategories">;

export async function fetchCategories(): Promise<Category[]> {
  const { data: cats, error: catError } = await supabase
    .from("categories")
    .select("*")
    .order("name");

  if (catError) throw catError;

  const { data: subs, error: subError } = await supabase
    .from("subcategories")
    .select("*");

  if (subError) throw subError;

  return (cats || []).map((cat) => ({
    id: cat.id,
    name: cat.name,
    slug: cat.slug,
    icon: cat.icon || "Smartphone",
    description: cat.description || "",
    productCount: cat.product_count || 0,
    subcategories: (subs || [])
      .filter((s) => s.category_id === cat.id)
      .map((s) => ({
        id: s.id,
        name: s.name,
        slug: s.slug,
      })),
  }));
}

export async function fetchCategoryBySlug(slug: string): Promise<Category | null> {
  const categories = await fetchCategories();
  return categories.find((c) => c.slug === slug) || null;
}
